    function initDynamicContentModal() {

        let modalLenis = null;
        let modalRafCancel = null;
        let modalGsapCtx = null;
        const modalLoaders = document.querySelectorAll('.content-modal-loader');
        const modalWindow = document.querySelector('#dynamic-content-modal');

        modalLoaders.forEach(modalLoader => {
            modalLoader.addEventListener('click', () => {
                const contentId = modalLoader.dataset.contentId;

                // Append URL
                const projectUrl = modalLoader.dataset.projectUrl;
                if (projectUrl) {
                    window.history.pushState({}, '', projectUrl);
                }

                if (contentId) {
                    const base = (window.noh_theme_ajax && window.noh_theme_ajax.rest_url) ? window.noh_theme_ajax.rest_url.replace(/\/?$/, '/') : '/wp-json/';
                    const url = base + 'noh/v1/project-html?id=' + encodeURIComponent(contentId);
                    fetch(url)
                        .then(r => r.json())
                        .then(({ html }) => {
                            document.documentElement.classList.add('modal-open');
                            // stop page lenis if present
                            if (window.lenis) {
                                window.lenis.stop();
                            }

                            modalWindow.classList.add('visible');
                            const contentEl = modalWindow.querySelector('.modal__content');
                            contentEl.innerHTML = html;

                            // init modal lenis after content is injected
                            const { instance, cancel } = initModalLenis(contentEl);
                            modalLenis = instance;
                            modalRafCancel = cancel;

                            // Build GSAP scroll animation for modal background (expand to full screen)
                            if (modalGsapCtx) {
                                modalGsapCtx.revert();
                            }
                            modalGsapCtx = gsap.context(() => {
                                //const maxScroll = () => (contentEl.scrollHeight - contentEl.clientHeight) || 1;
                                gsap.to(modalWindow, {
                                    '--gap': '0px',
                                    '--radius': '0px',
                                    '--modal-height': '100vh',
                                    '--container-top': '0px',
                                    ease: 'none',
                                    scrollTrigger: {
                                        trigger: contentEl,
                                        scroller: contentEl,
                                        start: 0,
                                        end: '500px',
                                        scrub: true,
                                    }
                                });
                            }, modalWindow);

                            // Initialize scroll sync for dynamically loaded content
                            setTimeout(() => {
                                initSingleProjectScrollSync(0.7); // 70% scroll speed for modal
                                // Force ScrollTrigger refresh after modal content is loaded
                            ScrollTrigger.refresh();
                            }, 100);
                        })
                        .catch(error => {
                            console.error('Error fetching project HTML:', error);
                        });
                }
            });
        });

        const modalClose = document.querySelector('#dynamic-content-modal .modal__close');

        function closeModal() {
            document.documentElement.classList.remove('modal-open');
            modalWindow.classList.remove('visible');

            // Reset scroll position so next open starts fresh
            const contentEl = modalWindow.querySelector('.modal__content');
            if (contentEl) {
                contentEl.scrollTop = 0;
            }

            // Remove URL
            const baseUrl = modalClose.dataset.baseUrl;
            if (baseUrl) {
                window.history.pushState({}, '', baseUrl);
            }

            if (modalLenis) {
                if (typeof modalRafCancel === 'function') modalRafCancel();
                modalLenis.destroy();
                modalLenis = null;
            }

            if (modalGsapCtx) {
                modalGsapCtx.revert();
                modalGsapCtx = null;
            }

            if (window.lenis) {
                window.lenis.start();
            }
        }

        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }

        // Close on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                if (modalWindow.classList.contains('visible')) {
                    e.preventDefault();
                    closeModal();
                }
            }
        });
    }
